import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HelpersService } from '../../../core/services/helpers.service';
import { OperationsService } from '../../../core/services/operations.service';
import { ScadenzaAdapter } from '../../components/fascicolo/scadenzario-update/scadenza-adapter';
import { Scadenza } from '../../models/scadenza';
import { MotivoScadenzaAuto } from '../../models/tipologiche/motivo-scadenza-auto';
import { Priorita } from '../../models/tipologiche/priorita';
import { TipoScadenza } from '../../models/tipologiche/tipo-scadenza';
import { BaseForm } from '../base-Form';
import { Observable, of, Subject, switchMap } from 'rxjs';
import { Utente } from '../../models/utente';
import { Motivo } from '../../models/tipologiche/motivo';

declare var removeEmptyObject: any;


export abstract class ScadenzarioFormComponent extends BaseForm {

  public request: Scadenza;
  scadenzaForm: FormGroup;
  ora: string;
  oraSet: string;
  minSet: string;
  isAttivitaTipoScadenza: boolean = false;
  idFascicolo: string;

  // options
  tipoScadenzaOptions: TipoScadenza[] = [];
  motivoScadenzaOptions: MotivoScadenzaAuto[] = [];
  motivoEvasioneOptions: Motivo[] = [];
  prioritaOptions: Priorita[] = [];
  listaAssegnatari: Utente [] = [];
  filteredAssegnatari: any[] = [];
  motivoScadenzaOptionsFiltrate: MotivoScadenzaAuto[] = [];
  // Subject che emetterà i termini di ricerca
  searchInput$ = new Subject<string>();
  // Observable che fornirà gli assegnatari filtrati
  filteredAssegnatari$: Observable<any[]>;



  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService) {
    super();
  }

  createForm() {
    this.isAttivitaTipoScadenza = false;
    this.request = new ScadenzaAdapter(this.getScadenza()).scadenza;
    this.scadenzaForm = this.campiForm.group({
      tipoScadenza: [this.request.tipoScadenza, Validators.required],
      motivo: [this.request.motivo, Validators.required],
      priorita: [this.request.priorita, Validators.required],
      dataScadenza: [this.request.dataScadenza, Validators.required],
      dataPromemoria: [this.request.dataPromemoria],
      pubblica: [this.request.pubblica],
      evasa: [this.request.evasa],
      dataEvasione: [this.request.dataEvasione],
      motivoEvasione: [this.request.motivoEvasione],
      appunto: [this.request.appunto],
      note: [this.request.note],
      ora: [this.ora],
      assegnatario: [this.request.assegnatario],
    });
    this.getOraFromDataScadenza(this.request.dataScadenza);
     if (this.request && this.request.tipoScadenza && this.request.tipoScadenza.id === 'ATTIVITA') {
      this.isAttivitaTipoScadenza = true;
    }

    // if (this.motivoScadenzaOptions.length === 0) {
    //   this.helpers.getMotiviScadenzaAutomatica().subscribe(response => {    
    //       this.motivoScadenzaOptions = response;
    //       if(this.request && this.request.tipoScadenza){
    //         this.motivoScadenzaOptionsFiltrate = this.motivoScadenzaOptions.filter(scadenza => scadenza.tipoScadenza.id == this.request.tipoScadenza.id);
    //       }else this.motivoScadenzaOptionsFiltrate = response;
    //   });
    // }
    const assegnatarioSalvato = this.listaAssegnatari?.find(a => a.username === this.request.assegnatario);
    if (assegnatarioSalvato) {
      this.scadenzaForm.controls['assegnatario'].setValue(assegnatarioSalvato);
    }
    this.termSearch();
  }

  private termSearch() {
    this.filteredAssegnatari$ = this.searchInput$.pipe(
      switchMap(term => {
        if (term && term.length >= 2) {
          return this.filterAssegnatari(term);
        } else {
          return of([]);
        }
      })
    );
  }

   // Funzione che filtra la lista in base al termine di ricerca
   filterAssegnatari(term: string): Observable<any[]> {
    if (!term) {
      // Se non c'è nessun termine, ritorna un array vuoto (così la lista non viene mostrata)
      return of([]);
    }
    const lowerTerm = term.toLowerCase();
    const filtered = this.listaAssegnatari.filter(item =>
      item.nome.toLowerCase().includes(lowerTerm) || 
      item.cognome.toLowerCase().includes(lowerTerm)
    );
    return of(filtered);
  }


  populateSelect(fascicoloGeneric: string) {
    if(this.motivoEvasioneOptions.length === 0) {
      this.helpers.getMotiviEvadiScadenza().subscribe(response => {
        this.motivoEvasioneOptions = response;
      });
    }
    if (this.tipoScadenzaOptions.length === 0) {
      //this.helpers.getTipiScadenza().subscribe(response => this.tipoScadenzaOptions = response);
        this.helpers.getTipiScadenza().subscribe(response => {
          // if(fascicoloGeneric != 'sinistrosanitario')
          //   this.tipoScadenzaOptions = response.filter(el => el.id != 'INCONTRO');
          //   else
              this.tipoScadenzaOptions = response;
        });

    }
    if (this.motivoScadenzaOptions.length === 0) {
      this.helpers.getMotiviScadenzaAutomatica().subscribe(response => {
        let motiviScadenzaSorted = response.sort((a,b) => a.label.localeCompare(b.label));
        this.motivoScadenzaOptions = motiviScadenzaSorted;
        this.motivoScadenzaOptionsFiltrate = motiviScadenzaSorted;
      });
    }
    if (this.prioritaOptions.length === 0) {
      this.helpers.getPrioritaScadenza().subscribe(response => this.prioritaOptions = response);
    }
    if (this.listaAssegnatari.length === 0) {
      this.helpers.getAssegnatariAdempimenti(this.idFascicolo).subscribe(response => {
        this.listaAssegnatari = response
      .map(user => {
        const nome = user.nome ? user.nome : '';
        const cognome = user.cognome ? user.cognome : '';

          return {
            ...user,
            cognomeNome: `${cognome} ${nome}`, // Concatenazione dei valori di nome e cognome
            username: user.username,
          };
        })
      .sort((a, b) => a.cognomeNome.localeCompare(b.cognomeNome)); // Ordinamento per cognomeNome

      const assegnatarioSalvato = this.listaAssegnatari.find(a => a.username === this.request.assegnatario);
      if (assegnatarioSalvato) {
        this.scadenzaForm.controls['assegnatario'].setValue(assegnatarioSalvato);
      }
      });
    }
  }

  getOraFromDataScadenza(dataScadenza: number) {
    if (dataScadenza) {
      let date = new Date(dataScadenza);
      this.oraSet = ('0' + date.getHours()).slice(-2);
      this.minSet = ('0' + date.getMinutes()).slice(-2);
      this.ora = this.oraSet + ':' + this.minSet;
    } else {
      this.oraSet = '00';
      this.minSet = '00';
      this.ora = '00:00';
    }
  }

  compareFn(a, b) {
    return a == b;
  }

  update() {
    let data = this.request.dataScadenza;
    let date = new Date(data);
    let oraMinuti: string[] = this.ora.split(':');
    date.setHours(Number(oraMinuti[0]), Number(oraMinuti[1]));
    this.request.dataScadenza = date.getTime();
    this.getRequest(this.request);
  }

  abstract getScadenza(): Scadenza;
  abstract getRequest(request: Scadenza);


  onChangeTipoScadenza(event: TipoScadenza){
    this.scadenzaForm.controls["tipoScadenza"].setValue(event);
    this.request.tipoScadenza = event;
    this.request.motivo = null;

    if(event){
        this.motivoScadenzaOptionsFiltrate = this.motivoScadenzaOptions.filter(scadenza => scadenza.tipoScadenza.id == event.id);
    }
    else{
        this.motivoScadenzaOptionsFiltrate = this.motivoScadenzaOptions;
    }
    if(event.id === 'ATTIVITA'){
      this.isAttivitaTipoScadenza = true
    } else {
      this.isAttivitaTipoScadenza = false;
      this.scadenzaForm.controls['assegnatario'].setValue(null);
    }
    if(event.id != 'UDIENZA' && this.request.dettaglioEsitoAdempimento){
      this.request.dettaglioEsitoAdempimento = null; 
    }
  }

  onEvasa(event) {
    this.request.evasa = event; 
    this.request.dataEvasione = null
    this.request.motivoEvasione = null;
  }


//passo il valore dell'elemento selezionato nel dropdown
  onSearchChange(searchTerm: string): void {
    // Invia il termine di ricerca a searchInput$
    this.searchInput$.next(searchTerm);
    this.termSearch();
  }
  
  onAssegnatarioSelected(event: any): void {
    this.request.assegnatario = event ? event.username : null;
  }

}
